/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkspaceRouteImport } from './routes/workspace'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ManagementRouteImport } from './routes/management'
import { Route as IndexRouteImport } from './routes/index'
import { Route as authVerifyEmailRouteImport } from './routes/(auth)/verify-email'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authAcceptInviteRouteImport } from './routes/(auth)/accept-invite'
import { Route as appOpsRouteImport } from './routes/(app)/ops'
import { Route as appOnboardingRouteImport } from './routes/(app)/onboarding'
import { Route as appDashboardRouteImport } from './routes/(app)/dashboard'
import { Route as authSelfServeSignupIndexRouteImport } from './routes/(auth)/self-serve-signup/index'
import { Route as appOpsIndexRouteImport } from './routes/(app)/ops/index'
import { Route as appDashboardIndexRouteImport } from './routes/(app)/dashboard/index'
import { Route as authSelfServeSignupVerifyRouteImport } from './routes/(auth)/self-serve-signup/verify'
import { Route as authOauthCompleteRouteImport } from './routes/(auth)/oauth/complete'
import { Route as authEmailChangeVerifyRouteImport } from './routes/(auth)/email-change/verify'
import { Route as authEmailChangeRevertRouteImport } from './routes/(auth)/email-change/revert'
import { Route as appOpsOrganisationsRouteImport } from './routes/(app)/ops/organisations'
import { Route as appOpsOnboardingRecordsRouteImport } from './routes/(app)/ops/onboarding-records'
import { Route as appOpsKraConnectionRouteImport } from './routes/(app)/ops/kra-connection'
import { Route as appOpsDeliveryRouteImport } from './routes/(app)/ops/delivery'
import { Route as appDashboardVerificationsRouteImport } from './routes/(app)/dashboard/verifications'
import { Route as appDashboardTccRouteImport } from './routes/(app)/dashboard/tcc'
import { Route as appDashboardTaxpulseRouteImport } from './routes/(app)/dashboard/taxpulse'
import { Route as appDashboardTaxReadinessRouteImport } from './routes/(app)/dashboard/tax-readiness'
import { Route as appDashboardSuppliersRouteImport } from './routes/(app)/dashboard/suppliers'
import { Route as appDashboardSettingsRouteImport } from './routes/(app)/dashboard/settings'
import { Route as appDashboardReconciliationRouteImport } from './routes/(app)/dashboard/reconciliation'
import { Route as appDashboardProductsRouteImport } from './routes/(app)/dashboard/products'
import { Route as appDashboardOrganisationRouteImport } from './routes/(app)/dashboard/organisation'
import { Route as appDashboardObligationsRouteImport } from './routes/(app)/dashboard/obligations'
import { Route as appDashboardLossLedgerRouteImport } from './routes/(app)/dashboard/loss-ledger'
import { Route as appDashboardInvoicesRouteImport } from './routes/(app)/dashboard/invoices'
import { Route as appDashboardInvoiceGateRouteImport } from './routes/(app)/dashboard/invoice-gate'
import { Route as appDashboardInstalmentTaxRouteImport } from './routes/(app)/dashboard/instalment-tax'
import { Route as appDashboardEvidenceRouteImport } from './routes/(app)/dashboard/evidence'
import { Route as appDashboardDocumentsRouteImport } from './routes/(app)/dashboard/documents'
import { Route as appDashboardDeveloperRouteImport } from './routes/(app)/dashboard/developer'
import { Route as appDashboardCustomsTradeRouteImport } from './routes/(app)/dashboard/customs-trade'
import { Route as appDashboardComplianceCalendarRouteImport } from './routes/(app)/dashboard/compliance-calendar'
import { Route as appDashboardBulkDocsRouteImport } from './routes/(app)/dashboard/bulk-docs'
import { Route as appDashboardAuditRiskRouteImport } from './routes/(app)/dashboard/audit-risk'
import { Route as appDashboardAuditResponseRouteImport } from './routes/(app)/dashboard/audit-response'
import { Route as appDashboardAuditReadinessRouteImport } from './routes/(app)/dashboard/audit-readiness'
import { Route as appOpsOrganisationsIndexRouteImport } from './routes/(app)/ops/organisations/index'
import { Route as appOpsKraConnectionIndexRouteImport } from './routes/(app)/ops/kra-connection/index'
import { Route as appOpsDeliveryIndexRouteImport } from './routes/(app)/ops/delivery/index'
import { Route as appOpsConnectionsIndexRouteImport } from './routes/(app)/ops/connections/index'
import { Route as appOpsAccessGrantsIndexRouteImport } from './routes/(app)/ops/access-grants/index'
import { Route as appDashboardSuppliersIndexRouteImport } from './routes/(app)/dashboard/suppliers/index'
import { Route as appDashboardSettingsIndexRouteImport } from './routes/(app)/dashboard/settings/index'
import { Route as appDashboardPeriodsIndexRouteImport } from './routes/(app)/dashboard/periods/index'
import { Route as appDashboardOrganisationIndexRouteImport } from './routes/(app)/dashboard/organisation/index'
import { Route as appDashboardObligationsIndexRouteImport } from './routes/(app)/dashboard/obligations/index'
import { Route as appDashboardInvoiceGateIndexRouteImport } from './routes/(app)/dashboard/invoice-gate/index'
import { Route as appDashboardAuditResponseIndexRouteImport } from './routes/(app)/dashboard/audit-response/index'
import { Route as appOpsOrganisationsTenantPublicIdRouteImport } from './routes/(app)/ops/organisations/$tenantPublicId'
import { Route as appOpsKraConnectionEndpointsRouteImport } from './routes/(app)/ops/kra-connection/endpoints'
import { Route as appOpsKraConnectionCredentialsRouteImport } from './routes/(app)/ops/kra-connection/credentials'
import { Route as appOpsKraConnectionAuditRouteImport } from './routes/(app)/ops/kra-connection/audit'
import { Route as appOpsDeliverySettingsRouteImport } from './routes/(app)/ops/delivery/settings'
import { Route as appOpsDeliveryOutboxRouteImport } from './routes/(app)/ops/delivery/outbox'
import { Route as appOpsDeliveryCatalogueRouteImport } from './routes/(app)/ops/delivery/catalogue'
import { Route as appOpsConnectionsEtimsRouteImport } from './routes/(app)/ops/connections/etims'
import { Route as appOpsConnectionsBrsRouteImport } from './routes/(app)/ops/connections/brs'
import { Route as appOpsAccessGrantsGrantPublicIdRouteImport } from './routes/(app)/ops/access-grants/$grantPublicId'
import { Route as appDashboardSuppliersSupplierIdRouteImport } from './routes/(app)/dashboard/suppliers/$supplierId'
import { Route as appDashboardSettingsUserProfileRouteImport } from './routes/(app)/dashboard/settings/user-profile'
import { Route as appDashboardSettingsSecurityRouteImport } from './routes/(app)/dashboard/settings/security'
import { Route as appDashboardSettingsPrivacyRouteImport } from './routes/(app)/dashboard/settings/privacy'
import { Route as appDashboardSettingsChangePasswordRouteImport } from './routes/(app)/dashboard/settings/change-password'
import { Route as appDashboardOrganisationProfileRouteImport } from './routes/(app)/dashboard/organisation/profile'
import { Route as appDashboardOrganisationPeopleRouteImport } from './routes/(app)/dashboard/organisation/people'
import { Route as appDashboardOrganisationEtimsRouteImport } from './routes/(app)/dashboard/organisation/etims'
import { Route as appDashboardOrganisationBillingRouteImport } from './routes/(app)/dashboard/organisation/billing'
import { Route as appDashboardObligationsTaxTypeRouteImport } from './routes/(app)/dashboard/obligations/$taxType'
import { Route as appDashboardInvoiceGateReviewRouteImport } from './routes/(app)/dashboard/invoice-gate/review'
import { Route as appDashboardInvoiceGateNewRouteImport } from './routes/(app)/dashboard/invoice-gate/new'
import { Route as appDashboardInvoiceGateBatchRouteImport } from './routes/(app)/dashboard/invoice-gate/batch'
import { Route as appDashboardInvoiceGateAssessmentIdRouteImport } from './routes/(app)/dashboard/invoice-gate/$assessmentId'
import { Route as appDashboardInvoiceExceptionDocumentIdRouteImport } from './routes/(app)/dashboard/invoice-exception/$documentId'
import { Route as appDashboardAuditResponseCaseIdRouteImport } from './routes/(app)/dashboard/audit-response/$caseId'
import { Route as appDashboardAdvisorOverviewRouteImport } from './routes/(app)/dashboard/advisor/overview'
import { Route as appDashboardAdvisorClientsRouteImport } from './routes/(app)/dashboard/advisor/clients'

const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/workspace',
  path: '/workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagementRoute = ManagementRouteImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const authVerifyEmailRoute = authVerifyEmailRouteImport.update({
  id: '/(auth)/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/(auth)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authAcceptInviteRoute = authAcceptInviteRouteImport.update({
  id: '/(auth)/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => rootRouteImport,
} as any)
const appOpsRoute = appOpsRouteImport.update({
  id: '/(app)/ops',
  path: '/ops',
  getParentRoute: () => rootRouteImport,
} as any)
const appOnboardingRoute = appOnboardingRouteImport.update({
  id: '/(app)/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const appDashboardRoute = appDashboardRouteImport.update({
  id: '/(app)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const authSelfServeSignupIndexRoute =
  authSelfServeSignupIndexRouteImport.update({
    id: '/(auth)/self-serve-signup/',
    path: '/self-serve-signup/',
    getParentRoute: () => rootRouteImport,
  } as any)
const appOpsIndexRoute = appOpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOpsRoute,
} as any)
const appDashboardIndexRoute = appDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appDashboardRoute,
} as any)
const authSelfServeSignupVerifyRoute =
  authSelfServeSignupVerifyRouteImport.update({
    id: '/(auth)/self-serve-signup/verify',
    path: '/self-serve-signup/verify',
    getParentRoute: () => rootRouteImport,
  } as any)
const authOauthCompleteRoute = authOauthCompleteRouteImport.update({
  id: '/(auth)/oauth/complete',
  path: '/oauth/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const authEmailChangeVerifyRoute = authEmailChangeVerifyRouteImport.update({
  id: '/(auth)/email-change/verify',
  path: '/email-change/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const authEmailChangeRevertRoute = authEmailChangeRevertRouteImport.update({
  id: '/(auth)/email-change/revert',
  path: '/email-change/revert',
  getParentRoute: () => rootRouteImport,
} as any)
const appOpsOrganisationsRoute = appOpsOrganisationsRouteImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => appOpsRoute,
} as any)
const appOpsOnboardingRecordsRoute = appOpsOnboardingRecordsRouteImport.update({
  id: '/onboarding-records',
  path: '/onboarding-records',
  getParentRoute: () => appOpsRoute,
} as any)
const appOpsKraConnectionRoute = appOpsKraConnectionRouteImport.update({
  id: '/kra-connection',
  path: '/kra-connection',
  getParentRoute: () => appOpsRoute,
} as any)
const appOpsDeliveryRoute = appOpsDeliveryRouteImport.update({
  id: '/delivery',
  path: '/delivery',
  getParentRoute: () => appOpsRoute,
} as any)
const appDashboardVerificationsRoute =
  appDashboardVerificationsRouteImport.update({
    id: '/verifications',
    path: '/verifications',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardTccRoute = appDashboardTccRouteImport.update({
  id: '/tcc',
  path: '/tcc',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardTaxpulseRoute = appDashboardTaxpulseRouteImport.update({
  id: '/taxpulse',
  path: '/taxpulse',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardTaxReadinessRoute =
  appDashboardTaxReadinessRouteImport.update({
    id: '/tax-readiness',
    path: '/tax-readiness',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardSuppliersRoute = appDashboardSuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardSettingsRoute = appDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardReconciliationRoute =
  appDashboardReconciliationRouteImport.update({
    id: '/reconciliation',
    path: '/reconciliation',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardProductsRoute = appDashboardProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardOrganisationRoute =
  appDashboardOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardObligationsRoute = appDashboardObligationsRouteImport.update({
  id: '/obligations',
  path: '/obligations',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardLossLedgerRoute = appDashboardLossLedgerRouteImport.update({
  id: '/loss-ledger',
  path: '/loss-ledger',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardInvoicesRoute = appDashboardInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardInvoiceGateRoute = appDashboardInvoiceGateRouteImport.update({
  id: '/invoice-gate',
  path: '/invoice-gate',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardInstalmentTaxRoute =
  appDashboardInstalmentTaxRouteImport.update({
    id: '/instalment-tax',
    path: '/instalment-tax',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardEvidenceRoute = appDashboardEvidenceRouteImport.update({
  id: '/evidence',
  path: '/evidence',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardDocumentsRoute = appDashboardDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardDeveloperRoute = appDashboardDeveloperRouteImport.update({
  id: '/developer',
  path: '/developer',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardCustomsTradeRoute =
  appDashboardCustomsTradeRouteImport.update({
    id: '/customs-trade',
    path: '/customs-trade',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardComplianceCalendarRoute =
  appDashboardComplianceCalendarRouteImport.update({
    id: '/compliance-calendar',
    path: '/compliance-calendar',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardBulkDocsRoute = appDashboardBulkDocsRouteImport.update({
  id: '/bulk-docs',
  path: '/bulk-docs',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardAuditRiskRoute = appDashboardAuditRiskRouteImport.update({
  id: '/audit-risk',
  path: '/audit-risk',
  getParentRoute: () => appDashboardRoute,
} as any)
const appDashboardAuditResponseRoute =
  appDashboardAuditResponseRouteImport.update({
    id: '/audit-response',
    path: '/audit-response',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardAuditReadinessRoute =
  appDashboardAuditReadinessRouteImport.update({
    id: '/audit-readiness',
    path: '/audit-readiness',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appOpsOrganisationsIndexRoute =
  appOpsOrganisationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOpsOrganisationsRoute,
  } as any)
const appOpsKraConnectionIndexRoute =
  appOpsKraConnectionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appOpsKraConnectionRoute,
  } as any)
const appOpsDeliveryIndexRoute = appOpsDeliveryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appOpsDeliveryRoute,
} as any)
const appOpsConnectionsIndexRoute = appOpsConnectionsIndexRouteImport.update({
  id: '/connections/',
  path: '/connections/',
  getParentRoute: () => appOpsRoute,
} as any)
const appOpsAccessGrantsIndexRoute = appOpsAccessGrantsIndexRouteImport.update({
  id: '/access-grants/',
  path: '/access-grants/',
  getParentRoute: () => appOpsRoute,
} as any)
const appDashboardSuppliersIndexRoute =
  appDashboardSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardSuppliersRoute,
  } as any)
const appDashboardSettingsIndexRoute =
  appDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardPeriodsIndexRoute =
  appDashboardPeriodsIndexRouteImport.update({
    id: '/periods/',
    path: '/periods/',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardOrganisationIndexRoute =
  appDashboardOrganisationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardOrganisationRoute,
  } as any)
const appDashboardObligationsIndexRoute =
  appDashboardObligationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardObligationsRoute,
  } as any)
const appDashboardInvoiceGateIndexRoute =
  appDashboardInvoiceGateIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardAuditResponseIndexRoute =
  appDashboardAuditResponseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => appDashboardAuditResponseRoute,
  } as any)
const appOpsOrganisationsTenantPublicIdRoute =
  appOpsOrganisationsTenantPublicIdRouteImport.update({
    id: '/$tenantPublicId',
    path: '/$tenantPublicId',
    getParentRoute: () => appOpsOrganisationsRoute,
  } as any)
const appOpsKraConnectionEndpointsRoute =
  appOpsKraConnectionEndpointsRouteImport.update({
    id: '/endpoints',
    path: '/endpoints',
    getParentRoute: () => appOpsKraConnectionRoute,
  } as any)
const appOpsKraConnectionCredentialsRoute =
  appOpsKraConnectionCredentialsRouteImport.update({
    id: '/credentials',
    path: '/credentials',
    getParentRoute: () => appOpsKraConnectionRoute,
  } as any)
const appOpsKraConnectionAuditRoute =
  appOpsKraConnectionAuditRouteImport.update({
    id: '/audit',
    path: '/audit',
    getParentRoute: () => appOpsKraConnectionRoute,
  } as any)
const appOpsDeliverySettingsRoute = appOpsDeliverySettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => appOpsDeliveryRoute,
} as any)
const appOpsDeliveryOutboxRoute = appOpsDeliveryOutboxRouteImport.update({
  id: '/outbox',
  path: '/outbox',
  getParentRoute: () => appOpsDeliveryRoute,
} as any)
const appOpsDeliveryCatalogueRoute = appOpsDeliveryCatalogueRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => appOpsDeliveryRoute,
} as any)
const appOpsConnectionsEtimsRoute = appOpsConnectionsEtimsRouteImport.update({
  id: '/connections/etims',
  path: '/connections/etims',
  getParentRoute: () => appOpsRoute,
} as any)
const appOpsConnectionsBrsRoute = appOpsConnectionsBrsRouteImport.update({
  id: '/connections/brs',
  path: '/connections/brs',
  getParentRoute: () => appOpsRoute,
} as any)
const appOpsAccessGrantsGrantPublicIdRoute =
  appOpsAccessGrantsGrantPublicIdRouteImport.update({
    id: '/access-grants/$grantPublicId',
    path: '/access-grants/$grantPublicId',
    getParentRoute: () => appOpsRoute,
  } as any)
const appDashboardSuppliersSupplierIdRoute =
  appDashboardSuppliersSupplierIdRouteImport.update({
    id: '/$supplierId',
    path: '/$supplierId',
    getParentRoute: () => appDashboardSuppliersRoute,
  } as any)
const appDashboardSettingsUserProfileRoute =
  appDashboardSettingsUserProfileRouteImport.update({
    id: '/user-profile',
    path: '/user-profile',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardSettingsSecurityRoute =
  appDashboardSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardSettingsPrivacyRoute =
  appDashboardSettingsPrivacyRouteImport.update({
    id: '/privacy',
    path: '/privacy',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardSettingsChangePasswordRoute =
  appDashboardSettingsChangePasswordRouteImport.update({
    id: '/change-password',
    path: '/change-password',
    getParentRoute: () => appDashboardSettingsRoute,
  } as any)
const appDashboardOrganisationProfileRoute =
  appDashboardOrganisationProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => appDashboardOrganisationRoute,
  } as any)
const appDashboardOrganisationPeopleRoute =
  appDashboardOrganisationPeopleRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => appDashboardOrganisationRoute,
  } as any)
const appDashboardOrganisationEtimsRoute =
  appDashboardOrganisationEtimsRouteImport.update({
    id: '/etims',
    path: '/etims',
    getParentRoute: () => appDashboardOrganisationRoute,
  } as any)
const appDashboardOrganisationBillingRoute =
  appDashboardOrganisationBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => appDashboardOrganisationRoute,
  } as any)
const appDashboardObligationsTaxTypeRoute =
  appDashboardObligationsTaxTypeRouteImport.update({
    id: '/$taxType',
    path: '/$taxType',
    getParentRoute: () => appDashboardObligationsRoute,
  } as any)
const appDashboardInvoiceGateReviewRoute =
  appDashboardInvoiceGateReviewRouteImport.update({
    id: '/review',
    path: '/review',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceGateNewRoute =
  appDashboardInvoiceGateNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceGateBatchRoute =
  appDashboardInvoiceGateBatchRouteImport.update({
    id: '/batch',
    path: '/batch',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceGateAssessmentIdRoute =
  appDashboardInvoiceGateAssessmentIdRouteImport.update({
    id: '/$assessmentId',
    path: '/$assessmentId',
    getParentRoute: () => appDashboardInvoiceGateRoute,
  } as any)
const appDashboardInvoiceExceptionDocumentIdRoute =
  appDashboardInvoiceExceptionDocumentIdRouteImport.update({
    id: '/invoice-exception/$documentId',
    path: '/invoice-exception/$documentId',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardAuditResponseCaseIdRoute =
  appDashboardAuditResponseCaseIdRouteImport.update({
    id: '/$caseId',
    path: '/$caseId',
    getParentRoute: () => appDashboardAuditResponseRoute,
  } as any)
const appDashboardAdvisorOverviewRoute =
  appDashboardAdvisorOverviewRouteImport.update({
    id: '/advisor/overview',
    path: '/advisor/overview',
    getParentRoute: () => appDashboardRoute,
  } as any)
const appDashboardAdvisorClientsRoute =
  appDashboardAdvisorClientsRouteImport.update({
    id: '/advisor/clients',
    path: '/advisor/clients',
    getParentRoute: () => appDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/management': typeof ManagementRoute
  '/privacy': typeof PrivacyRoute
  '/workspace': typeof WorkspaceRoute
  '/dashboard': typeof appDashboardRouteWithChildren
  '/onboarding': typeof appOnboardingRoute
  '/ops': typeof appOpsRouteWithChildren
  '/accept-invite': typeof authAcceptInviteRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/dashboard/audit-readiness': typeof appDashboardAuditReadinessRoute
  '/dashboard/audit-response': typeof appDashboardAuditResponseRouteWithChildren
  '/dashboard/audit-risk': typeof appDashboardAuditRiskRoute
  '/dashboard/bulk-docs': typeof appDashboardBulkDocsRoute
  '/dashboard/compliance-calendar': typeof appDashboardComplianceCalendarRoute
  '/dashboard/customs-trade': typeof appDashboardCustomsTradeRoute
  '/dashboard/developer': typeof appDashboardDeveloperRoute
  '/dashboard/documents': typeof appDashboardDocumentsRoute
  '/dashboard/evidence': typeof appDashboardEvidenceRoute
  '/dashboard/instalment-tax': typeof appDashboardInstalmentTaxRoute
  '/dashboard/invoice-gate': typeof appDashboardInvoiceGateRouteWithChildren
  '/dashboard/invoices': typeof appDashboardInvoicesRoute
  '/dashboard/loss-ledger': typeof appDashboardLossLedgerRoute
  '/dashboard/obligations': typeof appDashboardObligationsRouteWithChildren
  '/dashboard/organisation': typeof appDashboardOrganisationRouteWithChildren
  '/dashboard/products': typeof appDashboardProductsRoute
  '/dashboard/reconciliation': typeof appDashboardReconciliationRoute
  '/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/dashboard/suppliers': typeof appDashboardSuppliersRouteWithChildren
  '/dashboard/tax-readiness': typeof appDashboardTaxReadinessRoute
  '/dashboard/taxpulse': typeof appDashboardTaxpulseRoute
  '/dashboard/tcc': typeof appDashboardTccRoute
  '/dashboard/verifications': typeof appDashboardVerificationsRoute
  '/ops/delivery': typeof appOpsDeliveryRouteWithChildren
  '/ops/kra-connection': typeof appOpsKraConnectionRouteWithChildren
  '/ops/onboarding-records': typeof appOpsOnboardingRecordsRoute
  '/ops/organisations': typeof appOpsOrganisationsRouteWithChildren
  '/email-change/revert': typeof authEmailChangeRevertRoute
  '/email-change/verify': typeof authEmailChangeVerifyRoute
  '/oauth/complete': typeof authOauthCompleteRoute
  '/self-serve-signup/verify': typeof authSelfServeSignupVerifyRoute
  '/dashboard/': typeof appDashboardIndexRoute
  '/ops/': typeof appOpsIndexRoute
  '/self-serve-signup/': typeof authSelfServeSignupIndexRoute
  '/dashboard/advisor/clients': typeof appDashboardAdvisorClientsRoute
  '/dashboard/advisor/overview': typeof appDashboardAdvisorOverviewRoute
  '/dashboard/audit-response/$caseId': typeof appDashboardAuditResponseCaseIdRoute
  '/dashboard/invoice-exception/$documentId': typeof appDashboardInvoiceExceptionDocumentIdRoute
  '/dashboard/invoice-gate/$assessmentId': typeof appDashboardInvoiceGateAssessmentIdRoute
  '/dashboard/invoice-gate/batch': typeof appDashboardInvoiceGateBatchRoute
  '/dashboard/invoice-gate/new': typeof appDashboardInvoiceGateNewRoute
  '/dashboard/invoice-gate/review': typeof appDashboardInvoiceGateReviewRoute
  '/dashboard/obligations/$taxType': typeof appDashboardObligationsTaxTypeRoute
  '/dashboard/organisation/billing': typeof appDashboardOrganisationBillingRoute
  '/dashboard/organisation/etims': typeof appDashboardOrganisationEtimsRoute
  '/dashboard/organisation/people': typeof appDashboardOrganisationPeopleRoute
  '/dashboard/organisation/profile': typeof appDashboardOrganisationProfileRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/privacy': typeof appDashboardSettingsPrivacyRoute
  '/dashboard/settings/security': typeof appDashboardSettingsSecurityRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/suppliers/$supplierId': typeof appDashboardSuppliersSupplierIdRoute
  '/ops/access-grants/$grantPublicId': typeof appOpsAccessGrantsGrantPublicIdRoute
  '/ops/connections/brs': typeof appOpsConnectionsBrsRoute
  '/ops/connections/etims': typeof appOpsConnectionsEtimsRoute
  '/ops/delivery/catalogue': typeof appOpsDeliveryCatalogueRoute
  '/ops/delivery/outbox': typeof appOpsDeliveryOutboxRoute
  '/ops/delivery/settings': typeof appOpsDeliverySettingsRoute
  '/ops/kra-connection/audit': typeof appOpsKraConnectionAuditRoute
  '/ops/kra-connection/credentials': typeof appOpsKraConnectionCredentialsRoute
  '/ops/kra-connection/endpoints': typeof appOpsKraConnectionEndpointsRoute
  '/ops/organisations/$tenantPublicId': typeof appOpsOrganisationsTenantPublicIdRoute
  '/dashboard/audit-response/': typeof appDashboardAuditResponseIndexRoute
  '/dashboard/invoice-gate/': typeof appDashboardInvoiceGateIndexRoute
  '/dashboard/obligations/': typeof appDashboardObligationsIndexRoute
  '/dashboard/organisation/': typeof appDashboardOrganisationIndexRoute
  '/dashboard/periods/': typeof appDashboardPeriodsIndexRoute
  '/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/dashboard/suppliers/': typeof appDashboardSuppliersIndexRoute
  '/ops/access-grants/': typeof appOpsAccessGrantsIndexRoute
  '/ops/connections/': typeof appOpsConnectionsIndexRoute
  '/ops/delivery/': typeof appOpsDeliveryIndexRoute
  '/ops/kra-connection/': typeof appOpsKraConnectionIndexRoute
  '/ops/organisations/': typeof appOpsOrganisationsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/management': typeof ManagementRoute
  '/privacy': typeof PrivacyRoute
  '/workspace': typeof WorkspaceRoute
  '/onboarding': typeof appOnboardingRoute
  '/accept-invite': typeof authAcceptInviteRoute
  '/forgot-password': typeof authForgotPasswordRoute
  '/login': typeof authLoginRoute
  '/reset-password': typeof authResetPasswordRoute
  '/verify-email': typeof authVerifyEmailRoute
  '/dashboard/audit-readiness': typeof appDashboardAuditReadinessRoute
  '/dashboard/audit-risk': typeof appDashboardAuditRiskRoute
  '/dashboard/bulk-docs': typeof appDashboardBulkDocsRoute
  '/dashboard/compliance-calendar': typeof appDashboardComplianceCalendarRoute
  '/dashboard/customs-trade': typeof appDashboardCustomsTradeRoute
  '/dashboard/developer': typeof appDashboardDeveloperRoute
  '/dashboard/documents': typeof appDashboardDocumentsRoute
  '/dashboard/evidence': typeof appDashboardEvidenceRoute
  '/dashboard/instalment-tax': typeof appDashboardInstalmentTaxRoute
  '/dashboard/invoices': typeof appDashboardInvoicesRoute
  '/dashboard/loss-ledger': typeof appDashboardLossLedgerRoute
  '/dashboard/products': typeof appDashboardProductsRoute
  '/dashboard/reconciliation': typeof appDashboardReconciliationRoute
  '/dashboard/tax-readiness': typeof appDashboardTaxReadinessRoute
  '/dashboard/taxpulse': typeof appDashboardTaxpulseRoute
  '/dashboard/tcc': typeof appDashboardTccRoute
  '/dashboard/verifications': typeof appDashboardVerificationsRoute
  '/ops/onboarding-records': typeof appOpsOnboardingRecordsRoute
  '/email-change/revert': typeof authEmailChangeRevertRoute
  '/email-change/verify': typeof authEmailChangeVerifyRoute
  '/oauth/complete': typeof authOauthCompleteRoute
  '/self-serve-signup/verify': typeof authSelfServeSignupVerifyRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/ops': typeof appOpsIndexRoute
  '/self-serve-signup': typeof authSelfServeSignupIndexRoute
  '/dashboard/advisor/clients': typeof appDashboardAdvisorClientsRoute
  '/dashboard/advisor/overview': typeof appDashboardAdvisorOverviewRoute
  '/dashboard/audit-response/$caseId': typeof appDashboardAuditResponseCaseIdRoute
  '/dashboard/invoice-exception/$documentId': typeof appDashboardInvoiceExceptionDocumentIdRoute
  '/dashboard/invoice-gate/$assessmentId': typeof appDashboardInvoiceGateAssessmentIdRoute
  '/dashboard/invoice-gate/batch': typeof appDashboardInvoiceGateBatchRoute
  '/dashboard/invoice-gate/new': typeof appDashboardInvoiceGateNewRoute
  '/dashboard/invoice-gate/review': typeof appDashboardInvoiceGateReviewRoute
  '/dashboard/obligations/$taxType': typeof appDashboardObligationsTaxTypeRoute
  '/dashboard/organisation/billing': typeof appDashboardOrganisationBillingRoute
  '/dashboard/organisation/etims': typeof appDashboardOrganisationEtimsRoute
  '/dashboard/organisation/people': typeof appDashboardOrganisationPeopleRoute
  '/dashboard/organisation/profile': typeof appDashboardOrganisationProfileRoute
  '/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/dashboard/settings/privacy': typeof appDashboardSettingsPrivacyRoute
  '/dashboard/settings/security': typeof appDashboardSettingsSecurityRoute
  '/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/dashboard/suppliers/$supplierId': typeof appDashboardSuppliersSupplierIdRoute
  '/ops/access-grants/$grantPublicId': typeof appOpsAccessGrantsGrantPublicIdRoute
  '/ops/connections/brs': typeof appOpsConnectionsBrsRoute
  '/ops/connections/etims': typeof appOpsConnectionsEtimsRoute
  '/ops/delivery/catalogue': typeof appOpsDeliveryCatalogueRoute
  '/ops/delivery/outbox': typeof appOpsDeliveryOutboxRoute
  '/ops/delivery/settings': typeof appOpsDeliverySettingsRoute
  '/ops/kra-connection/audit': typeof appOpsKraConnectionAuditRoute
  '/ops/kra-connection/credentials': typeof appOpsKraConnectionCredentialsRoute
  '/ops/kra-connection/endpoints': typeof appOpsKraConnectionEndpointsRoute
  '/ops/organisations/$tenantPublicId': typeof appOpsOrganisationsTenantPublicIdRoute
  '/dashboard/audit-response': typeof appDashboardAuditResponseIndexRoute
  '/dashboard/invoice-gate': typeof appDashboardInvoiceGateIndexRoute
  '/dashboard/obligations': typeof appDashboardObligationsIndexRoute
  '/dashboard/organisation': typeof appDashboardOrganisationIndexRoute
  '/dashboard/periods': typeof appDashboardPeriodsIndexRoute
  '/dashboard/settings': typeof appDashboardSettingsIndexRoute
  '/dashboard/suppliers': typeof appDashboardSuppliersIndexRoute
  '/ops/access-grants': typeof appOpsAccessGrantsIndexRoute
  '/ops/connections': typeof appOpsConnectionsIndexRoute
  '/ops/delivery': typeof appOpsDeliveryIndexRoute
  '/ops/kra-connection': typeof appOpsKraConnectionIndexRoute
  '/ops/organisations': typeof appOpsOrganisationsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/management': typeof ManagementRoute
  '/privacy': typeof PrivacyRoute
  '/workspace': typeof WorkspaceRoute
  '/(app)/dashboard': typeof appDashboardRouteWithChildren
  '/(app)/onboarding': typeof appOnboardingRoute
  '/(app)/ops': typeof appOpsRouteWithChildren
  '/(auth)/accept-invite': typeof authAcceptInviteRoute
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/verify-email': typeof authVerifyEmailRoute
  '/(app)/dashboard/audit-readiness': typeof appDashboardAuditReadinessRoute
  '/(app)/dashboard/audit-response': typeof appDashboardAuditResponseRouteWithChildren
  '/(app)/dashboard/audit-risk': typeof appDashboardAuditRiskRoute
  '/(app)/dashboard/bulk-docs': typeof appDashboardBulkDocsRoute
  '/(app)/dashboard/compliance-calendar': typeof appDashboardComplianceCalendarRoute
  '/(app)/dashboard/customs-trade': typeof appDashboardCustomsTradeRoute
  '/(app)/dashboard/developer': typeof appDashboardDeveloperRoute
  '/(app)/dashboard/documents': typeof appDashboardDocumentsRoute
  '/(app)/dashboard/evidence': typeof appDashboardEvidenceRoute
  '/(app)/dashboard/instalment-tax': typeof appDashboardInstalmentTaxRoute
  '/(app)/dashboard/invoice-gate': typeof appDashboardInvoiceGateRouteWithChildren
  '/(app)/dashboard/invoices': typeof appDashboardInvoicesRoute
  '/(app)/dashboard/loss-ledger': typeof appDashboardLossLedgerRoute
  '/(app)/dashboard/obligations': typeof appDashboardObligationsRouteWithChildren
  '/(app)/dashboard/organisation': typeof appDashboardOrganisationRouteWithChildren
  '/(app)/dashboard/products': typeof appDashboardProductsRoute
  '/(app)/dashboard/reconciliation': typeof appDashboardReconciliationRoute
  '/(app)/dashboard/settings': typeof appDashboardSettingsRouteWithChildren
  '/(app)/dashboard/suppliers': typeof appDashboardSuppliersRouteWithChildren
  '/(app)/dashboard/tax-readiness': typeof appDashboardTaxReadinessRoute
  '/(app)/dashboard/taxpulse': typeof appDashboardTaxpulseRoute
  '/(app)/dashboard/tcc': typeof appDashboardTccRoute
  '/(app)/dashboard/verifications': typeof appDashboardVerificationsRoute
  '/(app)/ops/delivery': typeof appOpsDeliveryRouteWithChildren
  '/(app)/ops/kra-connection': typeof appOpsKraConnectionRouteWithChildren
  '/(app)/ops/onboarding-records': typeof appOpsOnboardingRecordsRoute
  '/(app)/ops/organisations': typeof appOpsOrganisationsRouteWithChildren
  '/(auth)/email-change/revert': typeof authEmailChangeRevertRoute
  '/(auth)/email-change/verify': typeof authEmailChangeVerifyRoute
  '/(auth)/oauth/complete': typeof authOauthCompleteRoute
  '/(auth)/self-serve-signup/verify': typeof authSelfServeSignupVerifyRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(app)/ops/': typeof appOpsIndexRoute
  '/(auth)/self-serve-signup/': typeof authSelfServeSignupIndexRoute
  '/(app)/dashboard/advisor/clients': typeof appDashboardAdvisorClientsRoute
  '/(app)/dashboard/advisor/overview': typeof appDashboardAdvisorOverviewRoute
  '/(app)/dashboard/audit-response/$caseId': typeof appDashboardAuditResponseCaseIdRoute
  '/(app)/dashboard/invoice-exception/$documentId': typeof appDashboardInvoiceExceptionDocumentIdRoute
  '/(app)/dashboard/invoice-gate/$assessmentId': typeof appDashboardInvoiceGateAssessmentIdRoute
  '/(app)/dashboard/invoice-gate/batch': typeof appDashboardInvoiceGateBatchRoute
  '/(app)/dashboard/invoice-gate/new': typeof appDashboardInvoiceGateNewRoute
  '/(app)/dashboard/invoice-gate/review': typeof appDashboardInvoiceGateReviewRoute
  '/(app)/dashboard/obligations/$taxType': typeof appDashboardObligationsTaxTypeRoute
  '/(app)/dashboard/organisation/billing': typeof appDashboardOrganisationBillingRoute
  '/(app)/dashboard/organisation/etims': typeof appDashboardOrganisationEtimsRoute
  '/(app)/dashboard/organisation/people': typeof appDashboardOrganisationPeopleRoute
  '/(app)/dashboard/organisation/profile': typeof appDashboardOrganisationProfileRoute
  '/(app)/dashboard/settings/change-password': typeof appDashboardSettingsChangePasswordRoute
  '/(app)/dashboard/settings/privacy': typeof appDashboardSettingsPrivacyRoute
  '/(app)/dashboard/settings/security': typeof appDashboardSettingsSecurityRoute
  '/(app)/dashboard/settings/user-profile': typeof appDashboardSettingsUserProfileRoute
  '/(app)/dashboard/suppliers/$supplierId': typeof appDashboardSuppliersSupplierIdRoute
  '/(app)/ops/access-grants/$grantPublicId': typeof appOpsAccessGrantsGrantPublicIdRoute
  '/(app)/ops/connections/brs': typeof appOpsConnectionsBrsRoute
  '/(app)/ops/connections/etims': typeof appOpsConnectionsEtimsRoute
  '/(app)/ops/delivery/catalogue': typeof appOpsDeliveryCatalogueRoute
  '/(app)/ops/delivery/outbox': typeof appOpsDeliveryOutboxRoute
  '/(app)/ops/delivery/settings': typeof appOpsDeliverySettingsRoute
  '/(app)/ops/kra-connection/audit': typeof appOpsKraConnectionAuditRoute
  '/(app)/ops/kra-connection/credentials': typeof appOpsKraConnectionCredentialsRoute
  '/(app)/ops/kra-connection/endpoints': typeof appOpsKraConnectionEndpointsRoute
  '/(app)/ops/organisations/$tenantPublicId': typeof appOpsOrganisationsTenantPublicIdRoute
  '/(app)/dashboard/audit-response/': typeof appDashboardAuditResponseIndexRoute
  '/(app)/dashboard/invoice-gate/': typeof appDashboardInvoiceGateIndexRoute
  '/(app)/dashboard/obligations/': typeof appDashboardObligationsIndexRoute
  '/(app)/dashboard/organisation/': typeof appDashboardOrganisationIndexRoute
  '/(app)/dashboard/periods/': typeof appDashboardPeriodsIndexRoute
  '/(app)/dashboard/settings/': typeof appDashboardSettingsIndexRoute
  '/(app)/dashboard/suppliers/': typeof appDashboardSuppliersIndexRoute
  '/(app)/ops/access-grants/': typeof appOpsAccessGrantsIndexRoute
  '/(app)/ops/connections/': typeof appOpsConnectionsIndexRoute
  '/(app)/ops/delivery/': typeof appOpsDeliveryIndexRoute
  '/(app)/ops/kra-connection/': typeof appOpsKraConnectionIndexRoute
  '/(app)/ops/organisations/': typeof appOpsOrganisationsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/management'
    | '/privacy'
    | '/workspace'
    | '/dashboard'
    | '/onboarding'
    | '/ops'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/dashboard/audit-readiness'
    | '/dashboard/audit-response'
    | '/dashboard/audit-risk'
    | '/dashboard/bulk-docs'
    | '/dashboard/compliance-calendar'
    | '/dashboard/customs-trade'
    | '/dashboard/developer'
    | '/dashboard/documents'
    | '/dashboard/evidence'
    | '/dashboard/instalment-tax'
    | '/dashboard/invoice-gate'
    | '/dashboard/invoices'
    | '/dashboard/loss-ledger'
    | '/dashboard/obligations'
    | '/dashboard/organisation'
    | '/dashboard/products'
    | '/dashboard/reconciliation'
    | '/dashboard/settings'
    | '/dashboard/suppliers'
    | '/dashboard/tax-readiness'
    | '/dashboard/taxpulse'
    | '/dashboard/tcc'
    | '/dashboard/verifications'
    | '/ops/delivery'
    | '/ops/kra-connection'
    | '/ops/onboarding-records'
    | '/ops/organisations'
    | '/email-change/revert'
    | '/email-change/verify'
    | '/oauth/complete'
    | '/self-serve-signup/verify'
    | '/dashboard/'
    | '/ops/'
    | '/self-serve-signup/'
    | '/dashboard/advisor/clients'
    | '/dashboard/advisor/overview'
    | '/dashboard/audit-response/$caseId'
    | '/dashboard/invoice-exception/$documentId'
    | '/dashboard/invoice-gate/$assessmentId'
    | '/dashboard/invoice-gate/batch'
    | '/dashboard/invoice-gate/new'
    | '/dashboard/invoice-gate/review'
    | '/dashboard/obligations/$taxType'
    | '/dashboard/organisation/billing'
    | '/dashboard/organisation/etims'
    | '/dashboard/organisation/people'
    | '/dashboard/organisation/profile'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/privacy'
    | '/dashboard/settings/security'
    | '/dashboard/settings/user-profile'
    | '/dashboard/suppliers/$supplierId'
    | '/ops/access-grants/$grantPublicId'
    | '/ops/connections/brs'
    | '/ops/connections/etims'
    | '/ops/delivery/catalogue'
    | '/ops/delivery/outbox'
    | '/ops/delivery/settings'
    | '/ops/kra-connection/audit'
    | '/ops/kra-connection/credentials'
    | '/ops/kra-connection/endpoints'
    | '/ops/organisations/$tenantPublicId'
    | '/dashboard/audit-response/'
    | '/dashboard/invoice-gate/'
    | '/dashboard/obligations/'
    | '/dashboard/organisation/'
    | '/dashboard/periods/'
    | '/dashboard/settings/'
    | '/dashboard/suppliers/'
    | '/ops/access-grants/'
    | '/ops/connections/'
    | '/ops/delivery/'
    | '/ops/kra-connection/'
    | '/ops/organisations/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/management'
    | '/privacy'
    | '/workspace'
    | '/onboarding'
    | '/accept-invite'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/dashboard/audit-readiness'
    | '/dashboard/audit-risk'
    | '/dashboard/bulk-docs'
    | '/dashboard/compliance-calendar'
    | '/dashboard/customs-trade'
    | '/dashboard/developer'
    | '/dashboard/documents'
    | '/dashboard/evidence'
    | '/dashboard/instalment-tax'
    | '/dashboard/invoices'
    | '/dashboard/loss-ledger'
    | '/dashboard/products'
    | '/dashboard/reconciliation'
    | '/dashboard/tax-readiness'
    | '/dashboard/taxpulse'
    | '/dashboard/tcc'
    | '/dashboard/verifications'
    | '/ops/onboarding-records'
    | '/email-change/revert'
    | '/email-change/verify'
    | '/oauth/complete'
    | '/self-serve-signup/verify'
    | '/dashboard'
    | '/ops'
    | '/self-serve-signup'
    | '/dashboard/advisor/clients'
    | '/dashboard/advisor/overview'
    | '/dashboard/audit-response/$caseId'
    | '/dashboard/invoice-exception/$documentId'
    | '/dashboard/invoice-gate/$assessmentId'
    | '/dashboard/invoice-gate/batch'
    | '/dashboard/invoice-gate/new'
    | '/dashboard/invoice-gate/review'
    | '/dashboard/obligations/$taxType'
    | '/dashboard/organisation/billing'
    | '/dashboard/organisation/etims'
    | '/dashboard/organisation/people'
    | '/dashboard/organisation/profile'
    | '/dashboard/settings/change-password'
    | '/dashboard/settings/privacy'
    | '/dashboard/settings/security'
    | '/dashboard/settings/user-profile'
    | '/dashboard/suppliers/$supplierId'
    | '/ops/access-grants/$grantPublicId'
    | '/ops/connections/brs'
    | '/ops/connections/etims'
    | '/ops/delivery/catalogue'
    | '/ops/delivery/outbox'
    | '/ops/delivery/settings'
    | '/ops/kra-connection/audit'
    | '/ops/kra-connection/credentials'
    | '/ops/kra-connection/endpoints'
    | '/ops/organisations/$tenantPublicId'
    | '/dashboard/audit-response'
    | '/dashboard/invoice-gate'
    | '/dashboard/obligations'
    | '/dashboard/organisation'
    | '/dashboard/periods'
    | '/dashboard/settings'
    | '/dashboard/suppliers'
    | '/ops/access-grants'
    | '/ops/connections'
    | '/ops/delivery'
    | '/ops/kra-connection'
    | '/ops/organisations'
  id:
    | '__root__'
    | '/'
    | '/management'
    | '/privacy'
    | '/workspace'
    | '/(app)/dashboard'
    | '/(app)/onboarding'
    | '/(app)/ops'
    | '/(auth)/accept-invite'
    | '/(auth)/forgot-password'
    | '/(auth)/login'
    | '/(auth)/reset-password'
    | '/(auth)/verify-email'
    | '/(app)/dashboard/audit-readiness'
    | '/(app)/dashboard/audit-response'
    | '/(app)/dashboard/audit-risk'
    | '/(app)/dashboard/bulk-docs'
    | '/(app)/dashboard/compliance-calendar'
    | '/(app)/dashboard/customs-trade'
    | '/(app)/dashboard/developer'
    | '/(app)/dashboard/documents'
    | '/(app)/dashboard/evidence'
    | '/(app)/dashboard/instalment-tax'
    | '/(app)/dashboard/invoice-gate'
    | '/(app)/dashboard/invoices'
    | '/(app)/dashboard/loss-ledger'
    | '/(app)/dashboard/obligations'
    | '/(app)/dashboard/organisation'
    | '/(app)/dashboard/products'
    | '/(app)/dashboard/reconciliation'
    | '/(app)/dashboard/settings'
    | '/(app)/dashboard/suppliers'
    | '/(app)/dashboard/tax-readiness'
    | '/(app)/dashboard/taxpulse'
    | '/(app)/dashboard/tcc'
    | '/(app)/dashboard/verifications'
    | '/(app)/ops/delivery'
    | '/(app)/ops/kra-connection'
    | '/(app)/ops/onboarding-records'
    | '/(app)/ops/organisations'
    | '/(auth)/email-change/revert'
    | '/(auth)/email-change/verify'
    | '/(auth)/oauth/complete'
    | '/(auth)/self-serve-signup/verify'
    | '/(app)/dashboard/'
    | '/(app)/ops/'
    | '/(auth)/self-serve-signup/'
    | '/(app)/dashboard/advisor/clients'
    | '/(app)/dashboard/advisor/overview'
    | '/(app)/dashboard/audit-response/$caseId'
    | '/(app)/dashboard/invoice-exception/$documentId'
    | '/(app)/dashboard/invoice-gate/$assessmentId'
    | '/(app)/dashboard/invoice-gate/batch'
    | '/(app)/dashboard/invoice-gate/new'
    | '/(app)/dashboard/invoice-gate/review'
    | '/(app)/dashboard/obligations/$taxType'
    | '/(app)/dashboard/organisation/billing'
    | '/(app)/dashboard/organisation/etims'
    | '/(app)/dashboard/organisation/people'
    | '/(app)/dashboard/organisation/profile'
    | '/(app)/dashboard/settings/change-password'
    | '/(app)/dashboard/settings/privacy'
    | '/(app)/dashboard/settings/security'
    | '/(app)/dashboard/settings/user-profile'
    | '/(app)/dashboard/suppliers/$supplierId'
    | '/(app)/ops/access-grants/$grantPublicId'
    | '/(app)/ops/connections/brs'
    | '/(app)/ops/connections/etims'
    | '/(app)/ops/delivery/catalogue'
    | '/(app)/ops/delivery/outbox'
    | '/(app)/ops/delivery/settings'
    | '/(app)/ops/kra-connection/audit'
    | '/(app)/ops/kra-connection/credentials'
    | '/(app)/ops/kra-connection/endpoints'
    | '/(app)/ops/organisations/$tenantPublicId'
    | '/(app)/dashboard/audit-response/'
    | '/(app)/dashboard/invoice-gate/'
    | '/(app)/dashboard/obligations/'
    | '/(app)/dashboard/organisation/'
    | '/(app)/dashboard/periods/'
    | '/(app)/dashboard/settings/'
    | '/(app)/dashboard/suppliers/'
    | '/(app)/ops/access-grants/'
    | '/(app)/ops/connections/'
    | '/(app)/ops/delivery/'
    | '/(app)/ops/kra-connection/'
    | '/(app)/ops/organisations/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ManagementRoute: typeof ManagementRoute
  PrivacyRoute: typeof PrivacyRoute
  WorkspaceRoute: typeof WorkspaceRoute
  appDashboardRoute: typeof appDashboardRouteWithChildren
  appOnboardingRoute: typeof appOnboardingRoute
  appOpsRoute: typeof appOpsRouteWithChildren
  authAcceptInviteRoute: typeof authAcceptInviteRoute
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authLoginRoute: typeof authLoginRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authVerifyEmailRoute: typeof authVerifyEmailRoute
  authEmailChangeRevertRoute: typeof authEmailChangeRevertRoute
  authEmailChangeVerifyRoute: typeof authEmailChangeVerifyRoute
  authOauthCompleteRoute: typeof authOauthCompleteRoute
  authSelfServeSignupVerifyRoute: typeof authSelfServeSignupVerifyRoute
  authSelfServeSignupIndexRoute: typeof authSelfServeSignupIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workspace': {
      id: '/workspace'
      path: '/workspace'
      fullPath: '/workspace'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management': {
      id: '/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof ManagementRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/verify-email': {
      id: '/(auth)/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof authVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/accept-invite': {
      id: '/(auth)/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof authAcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/ops': {
      id: '/(app)/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof appOpsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/onboarding': {
      id: '/(app)/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof appOnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/dashboard': {
      id: '/(app)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/self-serve-signup/': {
      id: '/(auth)/self-serve-signup/'
      path: '/self-serve-signup'
      fullPath: '/self-serve-signup/'
      preLoaderRoute: typeof authSelfServeSignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/ops/': {
      id: '/(app)/ops/'
      path: '/'
      fullPath: '/ops/'
      preLoaderRoute: typeof appOpsIndexRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof appDashboardIndexRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(auth)/self-serve-signup/verify': {
      id: '/(auth)/self-serve-signup/verify'
      path: '/self-serve-signup/verify'
      fullPath: '/self-serve-signup/verify'
      preLoaderRoute: typeof authSelfServeSignupVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/oauth/complete': {
      id: '/(auth)/oauth/complete'
      path: '/oauth/complete'
      fullPath: '/oauth/complete'
      preLoaderRoute: typeof authOauthCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/email-change/verify': {
      id: '/(auth)/email-change/verify'
      path: '/email-change/verify'
      fullPath: '/email-change/verify'
      preLoaderRoute: typeof authEmailChangeVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/email-change/revert': {
      id: '/(auth)/email-change/revert'
      path: '/email-change/revert'
      fullPath: '/email-change/revert'
      preLoaderRoute: typeof authEmailChangeRevertRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(app)/ops/organisations': {
      id: '/(app)/ops/organisations'
      path: '/organisations'
      fullPath: '/ops/organisations'
      preLoaderRoute: typeof appOpsOrganisationsRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/ops/onboarding-records': {
      id: '/(app)/ops/onboarding-records'
      path: '/onboarding-records'
      fullPath: '/ops/onboarding-records'
      preLoaderRoute: typeof appOpsOnboardingRecordsRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/ops/kra-connection': {
      id: '/(app)/ops/kra-connection'
      path: '/kra-connection'
      fullPath: '/ops/kra-connection'
      preLoaderRoute: typeof appOpsKraConnectionRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/ops/delivery': {
      id: '/(app)/ops/delivery'
      path: '/delivery'
      fullPath: '/ops/delivery'
      preLoaderRoute: typeof appOpsDeliveryRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/dashboard/verifications': {
      id: '/(app)/dashboard/verifications'
      path: '/verifications'
      fullPath: '/dashboard/verifications'
      preLoaderRoute: typeof appDashboardVerificationsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/tcc': {
      id: '/(app)/dashboard/tcc'
      path: '/tcc'
      fullPath: '/dashboard/tcc'
      preLoaderRoute: typeof appDashboardTccRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/taxpulse': {
      id: '/(app)/dashboard/taxpulse'
      path: '/taxpulse'
      fullPath: '/dashboard/taxpulse'
      preLoaderRoute: typeof appDashboardTaxpulseRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/tax-readiness': {
      id: '/(app)/dashboard/tax-readiness'
      path: '/tax-readiness'
      fullPath: '/dashboard/tax-readiness'
      preLoaderRoute: typeof appDashboardTaxReadinessRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/suppliers': {
      id: '/(app)/dashboard/suppliers'
      path: '/suppliers'
      fullPath: '/dashboard/suppliers'
      preLoaderRoute: typeof appDashboardSuppliersRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/settings': {
      id: '/(app)/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof appDashboardSettingsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/reconciliation': {
      id: '/(app)/dashboard/reconciliation'
      path: '/reconciliation'
      fullPath: '/dashboard/reconciliation'
      preLoaderRoute: typeof appDashboardReconciliationRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/products': {
      id: '/(app)/dashboard/products'
      path: '/products'
      fullPath: '/dashboard/products'
      preLoaderRoute: typeof appDashboardProductsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/organisation': {
      id: '/(app)/dashboard/organisation'
      path: '/organisation'
      fullPath: '/dashboard/organisation'
      preLoaderRoute: typeof appDashboardOrganisationRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/obligations': {
      id: '/(app)/dashboard/obligations'
      path: '/obligations'
      fullPath: '/dashboard/obligations'
      preLoaderRoute: typeof appDashboardObligationsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/loss-ledger': {
      id: '/(app)/dashboard/loss-ledger'
      path: '/loss-ledger'
      fullPath: '/dashboard/loss-ledger'
      preLoaderRoute: typeof appDashboardLossLedgerRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/invoices': {
      id: '/(app)/dashboard/invoices'
      path: '/invoices'
      fullPath: '/dashboard/invoices'
      preLoaderRoute: typeof appDashboardInvoicesRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/invoice-gate': {
      id: '/(app)/dashboard/invoice-gate'
      path: '/invoice-gate'
      fullPath: '/dashboard/invoice-gate'
      preLoaderRoute: typeof appDashboardInvoiceGateRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/instalment-tax': {
      id: '/(app)/dashboard/instalment-tax'
      path: '/instalment-tax'
      fullPath: '/dashboard/instalment-tax'
      preLoaderRoute: typeof appDashboardInstalmentTaxRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/evidence': {
      id: '/(app)/dashboard/evidence'
      path: '/evidence'
      fullPath: '/dashboard/evidence'
      preLoaderRoute: typeof appDashboardEvidenceRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/documents': {
      id: '/(app)/dashboard/documents'
      path: '/documents'
      fullPath: '/dashboard/documents'
      preLoaderRoute: typeof appDashboardDocumentsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/developer': {
      id: '/(app)/dashboard/developer'
      path: '/developer'
      fullPath: '/dashboard/developer'
      preLoaderRoute: typeof appDashboardDeveloperRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/customs-trade': {
      id: '/(app)/dashboard/customs-trade'
      path: '/customs-trade'
      fullPath: '/dashboard/customs-trade'
      preLoaderRoute: typeof appDashboardCustomsTradeRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/compliance-calendar': {
      id: '/(app)/dashboard/compliance-calendar'
      path: '/compliance-calendar'
      fullPath: '/dashboard/compliance-calendar'
      preLoaderRoute: typeof appDashboardComplianceCalendarRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/bulk-docs': {
      id: '/(app)/dashboard/bulk-docs'
      path: '/bulk-docs'
      fullPath: '/dashboard/bulk-docs'
      preLoaderRoute: typeof appDashboardBulkDocsRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/audit-risk': {
      id: '/(app)/dashboard/audit-risk'
      path: '/audit-risk'
      fullPath: '/dashboard/audit-risk'
      preLoaderRoute: typeof appDashboardAuditRiskRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/audit-response': {
      id: '/(app)/dashboard/audit-response'
      path: '/audit-response'
      fullPath: '/dashboard/audit-response'
      preLoaderRoute: typeof appDashboardAuditResponseRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/audit-readiness': {
      id: '/(app)/dashboard/audit-readiness'
      path: '/audit-readiness'
      fullPath: '/dashboard/audit-readiness'
      preLoaderRoute: typeof appDashboardAuditReadinessRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/ops/organisations/': {
      id: '/(app)/ops/organisations/'
      path: '/'
      fullPath: '/ops/organisations/'
      preLoaderRoute: typeof appOpsOrganisationsIndexRouteImport
      parentRoute: typeof appOpsOrganisationsRoute
    }
    '/(app)/ops/kra-connection/': {
      id: '/(app)/ops/kra-connection/'
      path: '/'
      fullPath: '/ops/kra-connection/'
      preLoaderRoute: typeof appOpsKraConnectionIndexRouteImport
      parentRoute: typeof appOpsKraConnectionRoute
    }
    '/(app)/ops/delivery/': {
      id: '/(app)/ops/delivery/'
      path: '/'
      fullPath: '/ops/delivery/'
      preLoaderRoute: typeof appOpsDeliveryIndexRouteImport
      parentRoute: typeof appOpsDeliveryRoute
    }
    '/(app)/ops/connections/': {
      id: '/(app)/ops/connections/'
      path: '/connections'
      fullPath: '/ops/connections/'
      preLoaderRoute: typeof appOpsConnectionsIndexRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/ops/access-grants/': {
      id: '/(app)/ops/access-grants/'
      path: '/access-grants'
      fullPath: '/ops/access-grants/'
      preLoaderRoute: typeof appOpsAccessGrantsIndexRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/dashboard/suppliers/': {
      id: '/(app)/dashboard/suppliers/'
      path: '/'
      fullPath: '/dashboard/suppliers/'
      preLoaderRoute: typeof appDashboardSuppliersIndexRouteImport
      parentRoute: typeof appDashboardSuppliersRoute
    }
    '/(app)/dashboard/settings/': {
      id: '/(app)/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof appDashboardSettingsIndexRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/periods/': {
      id: '/(app)/dashboard/periods/'
      path: '/periods'
      fullPath: '/dashboard/periods/'
      preLoaderRoute: typeof appDashboardPeriodsIndexRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/organisation/': {
      id: '/(app)/dashboard/organisation/'
      path: '/'
      fullPath: '/dashboard/organisation/'
      preLoaderRoute: typeof appDashboardOrganisationIndexRouteImport
      parentRoute: typeof appDashboardOrganisationRoute
    }
    '/(app)/dashboard/obligations/': {
      id: '/(app)/dashboard/obligations/'
      path: '/'
      fullPath: '/dashboard/obligations/'
      preLoaderRoute: typeof appDashboardObligationsIndexRouteImport
      parentRoute: typeof appDashboardObligationsRoute
    }
    '/(app)/dashboard/invoice-gate/': {
      id: '/(app)/dashboard/invoice-gate/'
      path: '/'
      fullPath: '/dashboard/invoice-gate/'
      preLoaderRoute: typeof appDashboardInvoiceGateIndexRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/audit-response/': {
      id: '/(app)/dashboard/audit-response/'
      path: '/'
      fullPath: '/dashboard/audit-response/'
      preLoaderRoute: typeof appDashboardAuditResponseIndexRouteImport
      parentRoute: typeof appDashboardAuditResponseRoute
    }
    '/(app)/ops/organisations/$tenantPublicId': {
      id: '/(app)/ops/organisations/$tenantPublicId'
      path: '/$tenantPublicId'
      fullPath: '/ops/organisations/$tenantPublicId'
      preLoaderRoute: typeof appOpsOrganisationsTenantPublicIdRouteImport
      parentRoute: typeof appOpsOrganisationsRoute
    }
    '/(app)/ops/kra-connection/endpoints': {
      id: '/(app)/ops/kra-connection/endpoints'
      path: '/endpoints'
      fullPath: '/ops/kra-connection/endpoints'
      preLoaderRoute: typeof appOpsKraConnectionEndpointsRouteImport
      parentRoute: typeof appOpsKraConnectionRoute
    }
    '/(app)/ops/kra-connection/credentials': {
      id: '/(app)/ops/kra-connection/credentials'
      path: '/credentials'
      fullPath: '/ops/kra-connection/credentials'
      preLoaderRoute: typeof appOpsKraConnectionCredentialsRouteImport
      parentRoute: typeof appOpsKraConnectionRoute
    }
    '/(app)/ops/kra-connection/audit': {
      id: '/(app)/ops/kra-connection/audit'
      path: '/audit'
      fullPath: '/ops/kra-connection/audit'
      preLoaderRoute: typeof appOpsKraConnectionAuditRouteImport
      parentRoute: typeof appOpsKraConnectionRoute
    }
    '/(app)/ops/delivery/settings': {
      id: '/(app)/ops/delivery/settings'
      path: '/settings'
      fullPath: '/ops/delivery/settings'
      preLoaderRoute: typeof appOpsDeliverySettingsRouteImport
      parentRoute: typeof appOpsDeliveryRoute
    }
    '/(app)/ops/delivery/outbox': {
      id: '/(app)/ops/delivery/outbox'
      path: '/outbox'
      fullPath: '/ops/delivery/outbox'
      preLoaderRoute: typeof appOpsDeliveryOutboxRouteImport
      parentRoute: typeof appOpsDeliveryRoute
    }
    '/(app)/ops/delivery/catalogue': {
      id: '/(app)/ops/delivery/catalogue'
      path: '/catalogue'
      fullPath: '/ops/delivery/catalogue'
      preLoaderRoute: typeof appOpsDeliveryCatalogueRouteImport
      parentRoute: typeof appOpsDeliveryRoute
    }
    '/(app)/ops/connections/etims': {
      id: '/(app)/ops/connections/etims'
      path: '/connections/etims'
      fullPath: '/ops/connections/etims'
      preLoaderRoute: typeof appOpsConnectionsEtimsRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/ops/connections/brs': {
      id: '/(app)/ops/connections/brs'
      path: '/connections/brs'
      fullPath: '/ops/connections/brs'
      preLoaderRoute: typeof appOpsConnectionsBrsRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/ops/access-grants/$grantPublicId': {
      id: '/(app)/ops/access-grants/$grantPublicId'
      path: '/access-grants/$grantPublicId'
      fullPath: '/ops/access-grants/$grantPublicId'
      preLoaderRoute: typeof appOpsAccessGrantsGrantPublicIdRouteImport
      parentRoute: typeof appOpsRoute
    }
    '/(app)/dashboard/suppliers/$supplierId': {
      id: '/(app)/dashboard/suppliers/$supplierId'
      path: '/$supplierId'
      fullPath: '/dashboard/suppliers/$supplierId'
      preLoaderRoute: typeof appDashboardSuppliersSupplierIdRouteImport
      parentRoute: typeof appDashboardSuppliersRoute
    }
    '/(app)/dashboard/settings/user-profile': {
      id: '/(app)/dashboard/settings/user-profile'
      path: '/user-profile'
      fullPath: '/dashboard/settings/user-profile'
      preLoaderRoute: typeof appDashboardSettingsUserProfileRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/settings/security': {
      id: '/(app)/dashboard/settings/security'
      path: '/security'
      fullPath: '/dashboard/settings/security'
      preLoaderRoute: typeof appDashboardSettingsSecurityRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/settings/privacy': {
      id: '/(app)/dashboard/settings/privacy'
      path: '/privacy'
      fullPath: '/dashboard/settings/privacy'
      preLoaderRoute: typeof appDashboardSettingsPrivacyRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/settings/change-password': {
      id: '/(app)/dashboard/settings/change-password'
      path: '/change-password'
      fullPath: '/dashboard/settings/change-password'
      preLoaderRoute: typeof appDashboardSettingsChangePasswordRouteImport
      parentRoute: typeof appDashboardSettingsRoute
    }
    '/(app)/dashboard/organisation/profile': {
      id: '/(app)/dashboard/organisation/profile'
      path: '/profile'
      fullPath: '/dashboard/organisation/profile'
      preLoaderRoute: typeof appDashboardOrganisationProfileRouteImport
      parentRoute: typeof appDashboardOrganisationRoute
    }
    '/(app)/dashboard/organisation/people': {
      id: '/(app)/dashboard/organisation/people'
      path: '/people'
      fullPath: '/dashboard/organisation/people'
      preLoaderRoute: typeof appDashboardOrganisationPeopleRouteImport
      parentRoute: typeof appDashboardOrganisationRoute
    }
    '/(app)/dashboard/organisation/etims': {
      id: '/(app)/dashboard/organisation/etims'
      path: '/etims'
      fullPath: '/dashboard/organisation/etims'
      preLoaderRoute: typeof appDashboardOrganisationEtimsRouteImport
      parentRoute: typeof appDashboardOrganisationRoute
    }
    '/(app)/dashboard/organisation/billing': {
      id: '/(app)/dashboard/organisation/billing'
      path: '/billing'
      fullPath: '/dashboard/organisation/billing'
      preLoaderRoute: typeof appDashboardOrganisationBillingRouteImport
      parentRoute: typeof appDashboardOrganisationRoute
    }
    '/(app)/dashboard/obligations/$taxType': {
      id: '/(app)/dashboard/obligations/$taxType'
      path: '/$taxType'
      fullPath: '/dashboard/obligations/$taxType'
      preLoaderRoute: typeof appDashboardObligationsTaxTypeRouteImport
      parentRoute: typeof appDashboardObligationsRoute
    }
    '/(app)/dashboard/invoice-gate/review': {
      id: '/(app)/dashboard/invoice-gate/review'
      path: '/review'
      fullPath: '/dashboard/invoice-gate/review'
      preLoaderRoute: typeof appDashboardInvoiceGateReviewRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-gate/new': {
      id: '/(app)/dashboard/invoice-gate/new'
      path: '/new'
      fullPath: '/dashboard/invoice-gate/new'
      preLoaderRoute: typeof appDashboardInvoiceGateNewRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-gate/batch': {
      id: '/(app)/dashboard/invoice-gate/batch'
      path: '/batch'
      fullPath: '/dashboard/invoice-gate/batch'
      preLoaderRoute: typeof appDashboardInvoiceGateBatchRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-gate/$assessmentId': {
      id: '/(app)/dashboard/invoice-gate/$assessmentId'
      path: '/$assessmentId'
      fullPath: '/dashboard/invoice-gate/$assessmentId'
      preLoaderRoute: typeof appDashboardInvoiceGateAssessmentIdRouteImport
      parentRoute: typeof appDashboardInvoiceGateRoute
    }
    '/(app)/dashboard/invoice-exception/$documentId': {
      id: '/(app)/dashboard/invoice-exception/$documentId'
      path: '/invoice-exception/$documentId'
      fullPath: '/dashboard/invoice-exception/$documentId'
      preLoaderRoute: typeof appDashboardInvoiceExceptionDocumentIdRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/audit-response/$caseId': {
      id: '/(app)/dashboard/audit-response/$caseId'
      path: '/$caseId'
      fullPath: '/dashboard/audit-response/$caseId'
      preLoaderRoute: typeof appDashboardAuditResponseCaseIdRouteImport
      parentRoute: typeof appDashboardAuditResponseRoute
    }
    '/(app)/dashboard/advisor/overview': {
      id: '/(app)/dashboard/advisor/overview'
      path: '/advisor/overview'
      fullPath: '/dashboard/advisor/overview'
      preLoaderRoute: typeof appDashboardAdvisorOverviewRouteImport
      parentRoute: typeof appDashboardRoute
    }
    '/(app)/dashboard/advisor/clients': {
      id: '/(app)/dashboard/advisor/clients'
      path: '/advisor/clients'
      fullPath: '/dashboard/advisor/clients'
      preLoaderRoute: typeof appDashboardAdvisorClientsRouteImport
      parentRoute: typeof appDashboardRoute
    }
  }
}

interface appDashboardAuditResponseRouteChildren {
  appDashboardAuditResponseCaseIdRoute: typeof appDashboardAuditResponseCaseIdRoute
  appDashboardAuditResponseIndexRoute: typeof appDashboardAuditResponseIndexRoute
}

const appDashboardAuditResponseRouteChildren: appDashboardAuditResponseRouteChildren =
  {
    appDashboardAuditResponseCaseIdRoute: appDashboardAuditResponseCaseIdRoute,
    appDashboardAuditResponseIndexRoute: appDashboardAuditResponseIndexRoute,
  }

const appDashboardAuditResponseRouteWithChildren =
  appDashboardAuditResponseRoute._addFileChildren(
    appDashboardAuditResponseRouteChildren,
  )

interface appDashboardInvoiceGateRouteChildren {
  appDashboardInvoiceGateAssessmentIdRoute: typeof appDashboardInvoiceGateAssessmentIdRoute
  appDashboardInvoiceGateBatchRoute: typeof appDashboardInvoiceGateBatchRoute
  appDashboardInvoiceGateNewRoute: typeof appDashboardInvoiceGateNewRoute
  appDashboardInvoiceGateReviewRoute: typeof appDashboardInvoiceGateReviewRoute
  appDashboardInvoiceGateIndexRoute: typeof appDashboardInvoiceGateIndexRoute
}

const appDashboardInvoiceGateRouteChildren: appDashboardInvoiceGateRouteChildren =
  {
    appDashboardInvoiceGateAssessmentIdRoute:
      appDashboardInvoiceGateAssessmentIdRoute,
    appDashboardInvoiceGateBatchRoute: appDashboardInvoiceGateBatchRoute,
    appDashboardInvoiceGateNewRoute: appDashboardInvoiceGateNewRoute,
    appDashboardInvoiceGateReviewRoute: appDashboardInvoiceGateReviewRoute,
    appDashboardInvoiceGateIndexRoute: appDashboardInvoiceGateIndexRoute,
  }

const appDashboardInvoiceGateRouteWithChildren =
  appDashboardInvoiceGateRoute._addFileChildren(
    appDashboardInvoiceGateRouteChildren,
  )

interface appDashboardObligationsRouteChildren {
  appDashboardObligationsTaxTypeRoute: typeof appDashboardObligationsTaxTypeRoute
  appDashboardObligationsIndexRoute: typeof appDashboardObligationsIndexRoute
}

const appDashboardObligationsRouteChildren: appDashboardObligationsRouteChildren =
  {
    appDashboardObligationsTaxTypeRoute: appDashboardObligationsTaxTypeRoute,
    appDashboardObligationsIndexRoute: appDashboardObligationsIndexRoute,
  }

const appDashboardObligationsRouteWithChildren =
  appDashboardObligationsRoute._addFileChildren(
    appDashboardObligationsRouteChildren,
  )

interface appDashboardOrganisationRouteChildren {
  appDashboardOrganisationBillingRoute: typeof appDashboardOrganisationBillingRoute
  appDashboardOrganisationEtimsRoute: typeof appDashboardOrganisationEtimsRoute
  appDashboardOrganisationPeopleRoute: typeof appDashboardOrganisationPeopleRoute
  appDashboardOrganisationProfileRoute: typeof appDashboardOrganisationProfileRoute
  appDashboardOrganisationIndexRoute: typeof appDashboardOrganisationIndexRoute
}

const appDashboardOrganisationRouteChildren: appDashboardOrganisationRouteChildren =
  {
    appDashboardOrganisationBillingRoute: appDashboardOrganisationBillingRoute,
    appDashboardOrganisationEtimsRoute: appDashboardOrganisationEtimsRoute,
    appDashboardOrganisationPeopleRoute: appDashboardOrganisationPeopleRoute,
    appDashboardOrganisationProfileRoute: appDashboardOrganisationProfileRoute,
    appDashboardOrganisationIndexRoute: appDashboardOrganisationIndexRoute,
  }

const appDashboardOrganisationRouteWithChildren =
  appDashboardOrganisationRoute._addFileChildren(
    appDashboardOrganisationRouteChildren,
  )

interface appDashboardSettingsRouteChildren {
  appDashboardSettingsChangePasswordRoute: typeof appDashboardSettingsChangePasswordRoute
  appDashboardSettingsPrivacyRoute: typeof appDashboardSettingsPrivacyRoute
  appDashboardSettingsSecurityRoute: typeof appDashboardSettingsSecurityRoute
  appDashboardSettingsUserProfileRoute: typeof appDashboardSettingsUserProfileRoute
  appDashboardSettingsIndexRoute: typeof appDashboardSettingsIndexRoute
}

const appDashboardSettingsRouteChildren: appDashboardSettingsRouteChildren = {
  appDashboardSettingsChangePasswordRoute:
    appDashboardSettingsChangePasswordRoute,
  appDashboardSettingsPrivacyRoute: appDashboardSettingsPrivacyRoute,
  appDashboardSettingsSecurityRoute: appDashboardSettingsSecurityRoute,
  appDashboardSettingsUserProfileRoute: appDashboardSettingsUserProfileRoute,
  appDashboardSettingsIndexRoute: appDashboardSettingsIndexRoute,
}

const appDashboardSettingsRouteWithChildren =
  appDashboardSettingsRoute._addFileChildren(appDashboardSettingsRouteChildren)

interface appDashboardSuppliersRouteChildren {
  appDashboardSuppliersSupplierIdRoute: typeof appDashboardSuppliersSupplierIdRoute
  appDashboardSuppliersIndexRoute: typeof appDashboardSuppliersIndexRoute
}

const appDashboardSuppliersRouteChildren: appDashboardSuppliersRouteChildren = {
  appDashboardSuppliersSupplierIdRoute: appDashboardSuppliersSupplierIdRoute,
  appDashboardSuppliersIndexRoute: appDashboardSuppliersIndexRoute,
}

const appDashboardSuppliersRouteWithChildren =
  appDashboardSuppliersRoute._addFileChildren(
    appDashboardSuppliersRouteChildren,
  )

interface appDashboardRouteChildren {
  appDashboardAuditReadinessRoute: typeof appDashboardAuditReadinessRoute
  appDashboardAuditResponseRoute: typeof appDashboardAuditResponseRouteWithChildren
  appDashboardAuditRiskRoute: typeof appDashboardAuditRiskRoute
  appDashboardBulkDocsRoute: typeof appDashboardBulkDocsRoute
  appDashboardComplianceCalendarRoute: typeof appDashboardComplianceCalendarRoute
  appDashboardCustomsTradeRoute: typeof appDashboardCustomsTradeRoute
  appDashboardDeveloperRoute: typeof appDashboardDeveloperRoute
  appDashboardDocumentsRoute: typeof appDashboardDocumentsRoute
  appDashboardEvidenceRoute: typeof appDashboardEvidenceRoute
  appDashboardInstalmentTaxRoute: typeof appDashboardInstalmentTaxRoute
  appDashboardInvoiceGateRoute: typeof appDashboardInvoiceGateRouteWithChildren
  appDashboardInvoicesRoute: typeof appDashboardInvoicesRoute
  appDashboardLossLedgerRoute: typeof appDashboardLossLedgerRoute
  appDashboardObligationsRoute: typeof appDashboardObligationsRouteWithChildren
  appDashboardOrganisationRoute: typeof appDashboardOrganisationRouteWithChildren
  appDashboardProductsRoute: typeof appDashboardProductsRoute
  appDashboardReconciliationRoute: typeof appDashboardReconciliationRoute
  appDashboardSettingsRoute: typeof appDashboardSettingsRouteWithChildren
  appDashboardSuppliersRoute: typeof appDashboardSuppliersRouteWithChildren
  appDashboardTaxReadinessRoute: typeof appDashboardTaxReadinessRoute
  appDashboardTaxpulseRoute: typeof appDashboardTaxpulseRoute
  appDashboardTccRoute: typeof appDashboardTccRoute
  appDashboardVerificationsRoute: typeof appDashboardVerificationsRoute
  appDashboardIndexRoute: typeof appDashboardIndexRoute
  appDashboardAdvisorClientsRoute: typeof appDashboardAdvisorClientsRoute
  appDashboardAdvisorOverviewRoute: typeof appDashboardAdvisorOverviewRoute
  appDashboardInvoiceExceptionDocumentIdRoute: typeof appDashboardInvoiceExceptionDocumentIdRoute
  appDashboardPeriodsIndexRoute: typeof appDashboardPeriodsIndexRoute
}

const appDashboardRouteChildren: appDashboardRouteChildren = {
  appDashboardAuditReadinessRoute: appDashboardAuditReadinessRoute,
  appDashboardAuditResponseRoute: appDashboardAuditResponseRouteWithChildren,
  appDashboardAuditRiskRoute: appDashboardAuditRiskRoute,
  appDashboardBulkDocsRoute: appDashboardBulkDocsRoute,
  appDashboardComplianceCalendarRoute: appDashboardComplianceCalendarRoute,
  appDashboardCustomsTradeRoute: appDashboardCustomsTradeRoute,
  appDashboardDeveloperRoute: appDashboardDeveloperRoute,
  appDashboardDocumentsRoute: appDashboardDocumentsRoute,
  appDashboardEvidenceRoute: appDashboardEvidenceRoute,
  appDashboardInstalmentTaxRoute: appDashboardInstalmentTaxRoute,
  appDashboardInvoiceGateRoute: appDashboardInvoiceGateRouteWithChildren,
  appDashboardInvoicesRoute: appDashboardInvoicesRoute,
  appDashboardLossLedgerRoute: appDashboardLossLedgerRoute,
  appDashboardObligationsRoute: appDashboardObligationsRouteWithChildren,
  appDashboardOrganisationRoute: appDashboardOrganisationRouteWithChildren,
  appDashboardProductsRoute: appDashboardProductsRoute,
  appDashboardReconciliationRoute: appDashboardReconciliationRoute,
  appDashboardSettingsRoute: appDashboardSettingsRouteWithChildren,
  appDashboardSuppliersRoute: appDashboardSuppliersRouteWithChildren,
  appDashboardTaxReadinessRoute: appDashboardTaxReadinessRoute,
  appDashboardTaxpulseRoute: appDashboardTaxpulseRoute,
  appDashboardTccRoute: appDashboardTccRoute,
  appDashboardVerificationsRoute: appDashboardVerificationsRoute,
  appDashboardIndexRoute: appDashboardIndexRoute,
  appDashboardAdvisorClientsRoute: appDashboardAdvisorClientsRoute,
  appDashboardAdvisorOverviewRoute: appDashboardAdvisorOverviewRoute,
  appDashboardInvoiceExceptionDocumentIdRoute:
    appDashboardInvoiceExceptionDocumentIdRoute,
  appDashboardPeriodsIndexRoute: appDashboardPeriodsIndexRoute,
}

const appDashboardRouteWithChildren = appDashboardRoute._addFileChildren(
  appDashboardRouteChildren,
)

interface appOpsDeliveryRouteChildren {
  appOpsDeliveryCatalogueRoute: typeof appOpsDeliveryCatalogueRoute
  appOpsDeliveryOutboxRoute: typeof appOpsDeliveryOutboxRoute
  appOpsDeliverySettingsRoute: typeof appOpsDeliverySettingsRoute
  appOpsDeliveryIndexRoute: typeof appOpsDeliveryIndexRoute
}

const appOpsDeliveryRouteChildren: appOpsDeliveryRouteChildren = {
  appOpsDeliveryCatalogueRoute: appOpsDeliveryCatalogueRoute,
  appOpsDeliveryOutboxRoute: appOpsDeliveryOutboxRoute,
  appOpsDeliverySettingsRoute: appOpsDeliverySettingsRoute,
  appOpsDeliveryIndexRoute: appOpsDeliveryIndexRoute,
}

const appOpsDeliveryRouteWithChildren = appOpsDeliveryRoute._addFileChildren(
  appOpsDeliveryRouteChildren,
)

interface appOpsKraConnectionRouteChildren {
  appOpsKraConnectionAuditRoute: typeof appOpsKraConnectionAuditRoute
  appOpsKraConnectionCredentialsRoute: typeof appOpsKraConnectionCredentialsRoute
  appOpsKraConnectionEndpointsRoute: typeof appOpsKraConnectionEndpointsRoute
  appOpsKraConnectionIndexRoute: typeof appOpsKraConnectionIndexRoute
}

const appOpsKraConnectionRouteChildren: appOpsKraConnectionRouteChildren = {
  appOpsKraConnectionAuditRoute: appOpsKraConnectionAuditRoute,
  appOpsKraConnectionCredentialsRoute: appOpsKraConnectionCredentialsRoute,
  appOpsKraConnectionEndpointsRoute: appOpsKraConnectionEndpointsRoute,
  appOpsKraConnectionIndexRoute: appOpsKraConnectionIndexRoute,
}

const appOpsKraConnectionRouteWithChildren =
  appOpsKraConnectionRoute._addFileChildren(appOpsKraConnectionRouteChildren)

interface appOpsOrganisationsRouteChildren {
  appOpsOrganisationsTenantPublicIdRoute: typeof appOpsOrganisationsTenantPublicIdRoute
  appOpsOrganisationsIndexRoute: typeof appOpsOrganisationsIndexRoute
}

const appOpsOrganisationsRouteChildren: appOpsOrganisationsRouteChildren = {
  appOpsOrganisationsTenantPublicIdRoute:
    appOpsOrganisationsTenantPublicIdRoute,
  appOpsOrganisationsIndexRoute: appOpsOrganisationsIndexRoute,
}

const appOpsOrganisationsRouteWithChildren =
  appOpsOrganisationsRoute._addFileChildren(appOpsOrganisationsRouteChildren)

interface appOpsRouteChildren {
  appOpsDeliveryRoute: typeof appOpsDeliveryRouteWithChildren
  appOpsKraConnectionRoute: typeof appOpsKraConnectionRouteWithChildren
  appOpsOnboardingRecordsRoute: typeof appOpsOnboardingRecordsRoute
  appOpsOrganisationsRoute: typeof appOpsOrganisationsRouteWithChildren
  appOpsIndexRoute: typeof appOpsIndexRoute
  appOpsAccessGrantsGrantPublicIdRoute: typeof appOpsAccessGrantsGrantPublicIdRoute
  appOpsConnectionsBrsRoute: typeof appOpsConnectionsBrsRoute
  appOpsConnectionsEtimsRoute: typeof appOpsConnectionsEtimsRoute
  appOpsAccessGrantsIndexRoute: typeof appOpsAccessGrantsIndexRoute
  appOpsConnectionsIndexRoute: typeof appOpsConnectionsIndexRoute
}

const appOpsRouteChildren: appOpsRouteChildren = {
  appOpsDeliveryRoute: appOpsDeliveryRouteWithChildren,
  appOpsKraConnectionRoute: appOpsKraConnectionRouteWithChildren,
  appOpsOnboardingRecordsRoute: appOpsOnboardingRecordsRoute,
  appOpsOrganisationsRoute: appOpsOrganisationsRouteWithChildren,
  appOpsIndexRoute: appOpsIndexRoute,
  appOpsAccessGrantsGrantPublicIdRoute: appOpsAccessGrantsGrantPublicIdRoute,
  appOpsConnectionsBrsRoute: appOpsConnectionsBrsRoute,
  appOpsConnectionsEtimsRoute: appOpsConnectionsEtimsRoute,
  appOpsAccessGrantsIndexRoute: appOpsAccessGrantsIndexRoute,
  appOpsConnectionsIndexRoute: appOpsConnectionsIndexRoute,
}

const appOpsRouteWithChildren =
  appOpsRoute._addFileChildren(appOpsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ManagementRoute: ManagementRoute,
  PrivacyRoute: PrivacyRoute,
  WorkspaceRoute: WorkspaceRoute,
  appDashboardRoute: appDashboardRouteWithChildren,
  appOnboardingRoute: appOnboardingRoute,
  appOpsRoute: appOpsRouteWithChildren,
  authAcceptInviteRoute: authAcceptInviteRoute,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authLoginRoute: authLoginRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authVerifyEmailRoute: authVerifyEmailRoute,
  authEmailChangeRevertRoute: authEmailChangeRevertRoute,
  authEmailChangeVerifyRoute: authEmailChangeVerifyRoute,
  authOauthCompleteRoute: authOauthCompleteRoute,
  authSelfServeSignupVerifyRoute: authSelfServeSignupVerifyRoute,
  authSelfServeSignupIndexRoute: authSelfServeSignupIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
